import { cloneDeep } from 'lodash';

const mutations = {
  SET_SESSIONS_LIST: (state, payload) => {
    state.sessionsList = payload;
  },
  PUSH_SESSION_LIST: (state, payload) => {
    const list = state.sessionsList;
    list.push(...payload);
    state.sessionsList = list;
  },
  SET_COMMUNICATION_CHANNEL_SESSIONS_LIST: (state, payload) => {
    state.communicationChannelSessionsList = payload;
  },
  PUSH_COMMUNICATION_CHANNEL_SESSION_LIST: (state, payload) => {
    const list = state.communicationChannelSessionsList;
    list.push(...payload);
    state.communicationChannelSessionsList = list;
  },
  SET_SESSIONS_LIST_LOADING: (state, payload) => {
    state.sessionsListLoading = payload;
  },
  SET_COMMUNICATION_CHANNEL_SESSIONS_LIST_LOADING: (state, payload) => {
    state.communicationChannelSessionsListLoading = payload;
  },
  SET_TOOL_SETS: (state, payload) => {
    state.toolSets = payload;
  },
  SET_TOOL_SETS_LOADING: (state, payload) => {
    state.toolSetsLoading = payload;
  },
  SET_CREATE_TOOL_SET_LOADING: (state, payload) => {
    state.createToolSetLoading = payload;
  },
  SET_CURRENT_TOOL_SET: (state, payload) => {
    state.currentToolSet = payload;
  },
  SET_CURRENT_TOOL_SET_LOADING: (state, payload) => {
    state.currentToolSetLoading = payload;
  },
  SET_CURRENT_SESSION: (state, payload) => {
    state.currentSession = payload;
  },
  SET_CURRENT_SESSION_LOADING: (state, payload) => {
    state.currentSessionLoading = payload;
  },
  SET_AI_RESPONSE_LOADING: (state, payload) => {
    state.AIResponseLoading = payload;
  },
  SET_USER_SETTINGS: (state, payload) => {
    state.userSettings = payload;
  },
  SET_USER_SETTINGS_LOADING: (state, payload) => {
    state.userSettingsLoading = payload;
  },
  SET_SYSTEM_PROMPTS: (state, payload) => {
    state.systemPrompts = payload;
  },
  SET_SYSTEM_PROMPT_LOADING: (state, payload) => {
    state.systemPromptLoading = payload;
  },
  SET_UPDATE_SYSTEM_PROMPT_LOADING: (state, payload) => {
    state.updateSystemPromptsLoading = payload;
  },
  SET_SEND_MESSAGE_LOADING: (state, payload) => {
    state.sendMessageLoading = payload;
  },
  CHANGE_SESSION_NAME: (state, payload) => {
    const sessionIndex = state.sessionsList.findIndex(
      (session) => session.id === payload.id
    );
    state.sessionsList[sessionIndex].name = payload.name;
  },
  CHANGE_SESSION_MEMORY: (state, payload) => {
    if (state.currentSession.id === payload.id) {
      state.currentSession.memory = payload.memory;
    }
  },
  SET_EDIT_SESSION: (state, payload) => {
    state.editSession = payload;
  },
  SET_EDIT_SYSTEM_PROMPT: (state, payload) => {
    state.editSystemPrompt = payload;
  },
  SET_EDIT_TOOL_SET: (state, payload) => {
    state.editToolSet = payload;
  },
  SET_SEND_MESSAGE: (state, payload) => {
    state.sendMessageData = payload;
  },
  SET_CHAT_WORKSPACE: (state, payload) => {
    state.chatWorkspace = payload;
  },
  SET_USER_AI_CARD: (state, payload) => {
    state.userAICard = payload;
  },
  SET_USER_AI_CARD_LOADING: (state, payload) => {
    state.userAICardLoading = payload;
  },
  ADD_MESSAGE_TO_CURRENT_SESSION: (state, payload) => {
    const currentSession = state.currentSession;
    if (currentSession?.Messages) {
      state.currentSession.Messages.push(payload);
    } else {
      state.currentSession.Messages = [payload];
    }
  },
  UPDATE_MESSAGE_IN_CURRENT_SESSION: (state, payload) => {
    const { messageIndex, content } = payload;
    const currentSession = state.currentSession;
    if (currentSession?.Messages[messageIndex]) {
      state.currentSession.Messages[messageIndex] = content;
    }
  },
  ADD_CONTENT_TO_CURRENT_SESSION_MESSAGE: (state, payload) => {
    const currentSession = state.currentSession;
    const { messageIndex, content } = payload;
    if (currentSession?.Messages?.[messageIndex]) {
      state.currentSession.Messages[messageIndex].content.push(content);
    }
  },
  UPDATE_CURRENT_SESSION_MESSAGE_CONTENT: (state, payload) => {
    const currentSession = state.currentSession;
    const { messageIndex, content, chunkIndex } = payload;
    if (currentSession?.Messages[messageIndex]) {
      state.currentSession.Messages[messageIndex].content[chunkIndex] = content;
      state.currentSession.Messages = cloneDeep(state.currentSession.Messages)
    }
  },
  SET_DELETE_SESSION_LOADING: (state, payload) => {
    state.deleteSessionLoading = payload;
  },
  SET_CHAT_ARTIFACT: (state, payload) => {
    state.artifact = payload;
  }
};

export default mutations;
